import { Editor, Range, Transforms, Element } from 'slate';

import { getBoundaries } from 'craft/rte/utils/getBoundaries';
import { getRandomId } from 'craft/utils';

import { unwrapLink } from './unwrapLink';

export interface LinkVariable {
  id: string;
  name: string;
  fallback: string;
}

export interface LinkDefinition {
  href: string;
  variables?: LinkVariable[];
}

export const wrapLink = (
  editor: Editor,
  linkDefinition: LinkDefinition,
  { typeLink }: { typeLink: string },
) => {
  const { selection } = editor;

  unwrapLink(editor, { typeLink });

  const isCollapsed = selection && Range.isCollapsed(selection);
  const { href, variables } = linkDefinition;

  const link: Element = {
    id: getRandomId(),
    type: typeLink,
    data: {
      props: {
        href,
      },
      custom: {
        variables,
      },
    },
    children: isCollapsed ? [{ id: getRandomId(), text: href }] : [],
  };

  if (isCollapsed) {
    Transforms.insertNodes(editor, link);
    return;
  }

  const boundaries = getBoundaries(editor);

  boundaries.forEach((boundary) =>
    Transforms.wrapNodes(editor, link, { split: true, at: boundary }),
  );

  Transforms.collapse(editor, { edge: 'end' });
};
